import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { BranchModel } from '@core/types';
import getBranches from '../api/getBranches';

const QUERY_KEY = 'branches';

export type UseBranchesResult = Omit<UseQueryResult<BranchModel[], any>, 'data'> & {
  branches: BranchModel[];
};

const useBranches = (): UseBranchesResult => {
  const { data: branches = [], ...rest } = useQuery({
    queryKey: [QUERY_KEY],
    queryFn: () => getBranches(),
    staleTime: 1000 * 60 * 60 * 12, // 12 hours
    cacheTime: 1000 * 60 * 60 * 12.5, // 12.5 hours
  });

  return { ...rest, branches };
};

export default useBranches;
